import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import tracking from "../../utils/tracking";
import { buildContentAction } from "../../services/content/actions";
import Question from "./Question";
import InTouch from "./InTouch";
import Newsletter from "../../components/_common/Newsletter";
import BookCta from "../../components/_common/BookCta";
import MetaDetail from "../../components/_common/MetaDetail";
import { HEADER_COPY, BODY_COPY } from "../../utils/content-keys";
import "./faqs.scss";

class Faqs extends Component {
	colors = ["yellow", "green", "red"];
	catIndex = 0;
	moduleNames = [
		{ name: "Page title", title: "Title" },
		{ name: "FAQ category|FAQs content", title: "Content" },
		{ name: "Get in Touch module", title: "InTouch" },
		{ name: "Book module (for mobile)", title: "BookCta" }
	];

	componentDidMount() {
		tracking.pageView("/faqs");
		window.scrollTo(0, 0);

		if (!this.props.data.fetchedData) {
			this.props.fetchData(
				{ name: "faqsPage", modules: this.moduleNames, transform: true },
				true,
				"FAQS"
			);
		} else if (!this.props.data.built && this.props.data.data) {
			this.props.buildContentAction(this.props.data.data, {
				name: "faqsPage",
				modules: this.moduleNames,
				transform: true
			});
		} else {
			console.log("FaqsPage - data fetched");
		}
	}

	getCustomMeta = contents => {
		return [
			{
				type: "application/ld+json",
				innerHTML: `{
	      "@context": "http://schema.org/",
	      "@graph": [${contents.Content.filter(item => item[BODY_COPY].value).map(
					item => `{
	        "@type": "AskAction",
	        "agent": {
	          "@type": "Organization",
	          "name": "Guinness"
	        },
	        "question": {
	            "text": "${item[HEADER_COPY].value}",
	            "acceptedAnswer": "${item[BODY_COPY].value.replace(/\n|\r/g, "")}"
	          }
	        }`
				)}]
	    }`
			}
		];
	};

	render() {
		if (!this.props.data || !this.props.data.contents) {
			return;
		}
		const { contents } = this.props.data;

		if (!contents) {
			return null;
		}
		let ownMetatitle = ''
		let ownMetadescription = ''

		if (!contents.meta) {
			ownMetatitle = "FAQs about the Guinness Open Gate Brewery, St James"
			ownMetadescription = "Get the answers to all your questions about the Guinness Open Gate Brewery - accessibility, parking, facilities, groups, ticket bookings and more."
		}


		return (
			<div role="main" aria-label="Faq Page" className="faqs">
				<Helmet>
					<title>{ownMetatitle}</title>
					<meta name='description' content={ownMetadescription} />
					<link rel='canonical' href={window.location.href} />
				</Helmet>
				<h1 className="faqs__header">{contents.Title[0][HEADER_COPY].value}</h1>

				{contents.Content.map((item, index) =>
					item[BODY_COPY].value ? (
						<Question question={item} key={`faqItem_${index}`} />
					) : (
							<h3
								className={`faqs__category faqs__category--${
									this.colors[this.catIndex++ % this.colors.length]
									}`}
								key={`faqCategory_${index}`}
							>
								{item[HEADER_COPY].value}
							</h3>
						)
				)}
				<InTouch content={contents.InTouch[0]} />
				{/* <Newsletter /> */}
				{/* <BookCta
					content={contents.BookCta[0]}
					routeProps={this.props.routeProps}
				/> */}
			</div>
		);
	}
}

export default connect(
	() => ({}),
	{ buildContentAction }
)(Faqs);



// WEBPACK FOOTER //
// ./src/pages/faqs/index.js